"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanAccountAndBranchStrings = exports.getMultipliersAndAccountProduct = exports.getUnitDigit = exports.getSumOfDigits = exports.getAccountAndDigit = exports.getBranchAndDigit = exports.leftPad = void 0;
function leftPad() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var padValue = arguments.length > 1 ? arguments[1] : undefined;
  var len = arguments.length > 2 ? arguments[2] : undefined;
  if (value.length >= len) {
    return value;
  }
  var padLength = len - value.length;
  var padStr = String(padValue).repeat(padLength) + value;
  return padStr;
}
exports.leftPad = leftPad;
function getBranchAndDigit(bankBranch, dvLen) {
  var numberDvLen = Number(dvLen);
  var branch = bankBranch.slice(0, bankBranch.length - numberDvLen);
  var branchDigit = bankBranch.slice(bankBranch.length - numberDvLen);
  return {
    branch: branch,
    branchDigit: branchDigit
  };
}
exports.getBranchAndDigit = getBranchAndDigit;
function getAccountAndDigit(bankAccount) {
  var account = bankAccount.slice(0, bankAccount.length - 1);
  var accountDigit = bankAccount.slice(bankAccount.length - 1);
  return {
    account: account,
    accountDigit: accountDigit
  };
}
exports.getAccountAndDigit = getAccountAndDigit;
function getSumOfDigits(num) {
  var numString = num.toString();
  if (numString.length === 1) {
    return num;
  }
  var numDigits = numString.split('');
  var sum = numDigits.reduce(function (acc, digit) {
    return acc + parseInt(digit);
  }, 0);
  return sum;
}
exports.getSumOfDigits = getSumOfDigits;
function getUnitDigit(num) {
  var numString = num.toString();
  if (numString.length === 1) {
    return num;
  }
  var unitDigit = parseInt(numString.slice(-1));
  return unitDigit;
}
exports.getUnitDigit = getUnitDigit;
;
var getMultipliersAndAccountProduct = function getMultipliersAndAccountProduct(weights, accountData, prodModifier) {
  var result = weights.reduce(function (acc, currentValue, idx) {
    var multiplier = parseInt(currentValue);
    var accDigit = parseInt(accountData[idx]);
    var product = multiplier * accDigit;
    if (prodModifier) {
      var processedProduct = Number(prodModifier(product));
      return acc + processedProduct;
    }
    return acc + product;
  }, 0);
  return result;
};
exports.getMultipliersAndAccountProduct = getMultipliersAndAccountProduct;
function cleanAccountAndBranchStrings(bankAccount, bankBranch) {
  var formattedBranch = bankBranch.replace(/[.-]+/gi, '');
  var formattedAccount = bankAccount.replace(/[.-]+/gi, '');
  return {
    formattedAccount: formattedAccount,
    formattedBranch: formattedBranch
  };
}
exports.cleanAccountAndBranchStrings = cleanAccountAndBranchStrings;